module.exports = __webpack_public_path__ + "assets/img/btn-detail-adee5583.png";